import { fluentIconFontSizeSx } from '@/theme/sx/fluentIconWrapperSx.js'

export const copyIcon14Sx = fluentIconFontSizeSx(14)
export const copyIcon16Sx = fluentIconFontSizeSx(16)
